import jwtDecode from 'jwt-decode'

export default {
    data() {
        return {
            initialSetup: null,
            dateRange: {
                startDate: moment().subtract('year', 1).startOf('year').toDate(),
                endDate: moment().toDate()
            },
            profileIDs: jwtDecode(Spark.jwtToken).user.instagramProfileIDs,
            jwtHashtags: jwtDecode(Spark.jwtToken).user.hashtags,
            locations: jwtDecode(Spark.jwtToken).user.locations,
            selectedProfiles: jwtDecode(Spark.jwtToken).user.instagramProfileIDs,
            selectedHashtags: jwtDecode(Spark.jwtToken).user.hashtags,
            selectedLocations: jwtDecode(Spark.jwtToken).user.locations,
            loading: false,
            pickerOptions: {
                // Instagram launch date :P
                // minDate: '2010-10-06',
                minDate: null,
                maxDate: null,
                opens: 'center',
                singleDatePicker: false,
                localeDate: { firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }
            }
        }
    },
    created() {
        if (this.profileIDs.length || this.jwtHashtags.length || this.locations.length) {
            this.initialSetup = true
        } else {
            this.initialSetup = false
        }
    }
}
